import { render } from "./Planes.vue?vue&type=template&id=678f2ca0&scoped=true"
const script = {}

import "./Planes.vue?vue&type=style&index=0&id=678f2ca0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678f2ca0"]])

export default __exports__